module.exports = "<!-- Loader overlay -->\n<div class=\"loading-overlay\" ng-show=\"$ctrl.isLoading\">\n    <div class=\"inner\">\n        <img ng-src=\"{{$ctrl.loadingImage}}\"/>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/loaderScreen/loaderScreen.html
// module id = 608
// module chunks = 0